import firebase from "firebase";
import {
  MAIL_LOADING,
  MAIL_LOADING_END,
  MAIL_SENT,
  MAIL_SENT_FAIL,
  MAIL_SENT_RESET,
  QUERY_SENT,
  QUERY_SENT_FAIL,
} from "./types";
import axios from "axios";

export const sendMail = (mail) => async (dispatch) => {
  dispatch({
    type: MAIL_LOADING,
  });
  var body = {
    ...mail,
  };
  const config = {
    headers: {
      "Content-Type": " application/json",
    },
  };
  axios
    .post(
      "https://us-central1-cr-mobile-13fb4.cloudfunctions.net/app/api/v1/mail/sendMail",
      body,
      config
    )
    .then((res) => {
      console.log(res.data.success);
      if (res.data.success) {
        dispatch({ type: MAIL_SENT });
      } else {
        dispatch({ type: MAIL_SENT_FAIL });
      }
      dispatch({
        type: MAIL_LOADING_END,
      });
    })
    .catch((err) => {
      dispatch({ type: MAIL_SENT_FAIL });
      dispatch({
        type: MAIL_LOADING_END,
      });
    });
};

export const mailReset = () => async (dispatch) => {
  dispatch({
    type: MAIL_SENT_RESET,
  });
};

export const queryMail = (mail) => async (dispatch) => {
  dispatch({
    type: MAIL_LOADING,
  });
  var body = {
    ...mail,
  };
  const config = {
    headers: {
      "Content-Type": " application/json",
    },
  };
  axios
    .post(
      "https://us-central1-cr-mobile-13fb4.cloudfunctions.net/app/api/v1/mail/queryMail",
      body,
      config
    )
    .then((res) => {
      console.log(res.data.success);
      if (res.data.success) {
        dispatch({ type: MAIL_SENT });
      } else {
        dispatch({ type: MAIL_SENT_FAIL });
      }
      dispatch({
        type: MAIL_LOADING_END,
      });
    })
    .catch((err) => {
      dispatch({ type: MAIL_SENT_FAIL });
      dispatch({
        type: MAIL_LOADING_END,
      });
    });
};
